import { render, staticRenderFns } from "./historyResponsibilityDialog.vue?vue&type=template&id=418e7070&scoped=true"
import script from "./historyResponsibilityDialog.vue?vue&type=script&lang=js"
export * from "./historyResponsibilityDialog.vue?vue&type=script&lang=js"
import style0 from "./historyResponsibilityDialog.vue?vue&type=style&index=0&id=418e7070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418e7070",
  null
  
)

export default component.exports